import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { makeDebugger } from 'lib';
import LoaderPage from 'components/LoaderPage';

const debug = makeDebugger('StartupLoader');


class StartupLoader extends Component {
  state = {
    isLoggingIn: false,
    isLoggingOut: false
  }

  componentWillReceiveProps(nextProps) {
    const isLoggingOut = this.props.isAuthed && !nextProps.isAuthed
    const isLoggingIn = !this.props.isAuthed && nextProps.isAuthed
    debug('componentWillReceiveProps()');
    debug('to props: ', nextProps);

    this.setState({ isLoggingIn, isLoggingOut });
  }

  render() {
    const { loading, location, isAuthed } = this.props;
    const { isLoggingIn, isLoggingOut } = this.state;
    debug('location', location);

    const from = location.state ? location.state.from : { from: { pathname: '/app' }};

    // If auth state isn't loading, and it's a user isn't authenticated, then we
    // know we've reached the final auth state and can return the logout experience.
    if ((!loading && !isAuthed) || isLoggingOut) {
      return <Redirect to={{ pathname: '/login', state: { from: location }}} />
    } else if (isLoggingIn || isAuthed) {
      const path = from === '/' ? '/app' : from;
      return <Redirect to={path} />;
    }

    return <LoaderPage loading={true} />;
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    loading: auth.loading,
    isAuthed: auth.isAuthed
  }
}

export default connect(mapStateToProps)(StartupLoader);;



// WEBPACK FOOTER //
// ./src/containers/StartupLoader.js